export const STORE_USER_PREFS: string = 'USER_PREFS';
export const STORE_USER_AUTH: string = 'USER_AUTH';
export const STORE_COMPANY_PREFS: string = 'COMPANY_PREFS';
export const STORE_DATA: string = 'DATA';
export const STORE_SANDBOX: string = 'SANDBOX';
export const STORE_LOCALE: string = 'LOCALE';
export const STORE_EXPORT_FIELD_PREFS = 'EXPORT_FIELDS';
export const STORE_LOGIN_PREFS = 'LOGIN_PREFS';